<template>
    <div class="game">
         <!-- Ready Go -->
        <!-- <h1  :class="[goActiveFlag?'goActive':'','word-go']" @animationend="reset" v-if="!timeoutShow">Ready Go</h1> -->
        <h1  :class="goActiveFlag?'word-go':''" v-if="goActiveFlag&&!timeoutShow">Ready Go</h1>
        <audio src="./../../assets/audio/go.mp3" id="go"  v-if="!timeoutShow" controls hidden='true' preload="auto" ref="go" ></audio>
        <!-- <audio src="./../../assets/audio/bgmusic.mp3" id="bgmusic"  ref="bgmusic" preload="auto" loop  autoplay controls></audio> -->
        <div class="game_top">
            <img src="@/assets/images/game/back.png" class="game_top_back" @click="goBackbox" />
            <div class="game_top_guanka">
                <p class="game_top_guanka_title">关卡</p>
                <p class="game_top_guanka_num">0{{level}}</p>
            </div>
            <div class="game_top_times">
                <p>{{gameTimes}}次</p>
            </div>
            <div class="game_top_process">
                <div class="game_top_process_bar">
                    <div class="game_top_process_bar_left" :style="{width:100/barWidth*time+'%'}"></div>
                    <div class="game_top_process_bar_right" :style="{width:(100-100/barWidth*time)+'%'}"></div>
                    <img :src="require('@/assets/images/game/' + starPicOne + '.png')" class="game_top_process_bar_starone game_top_process_bar_star" />
                    <img :src="require('@/assets/images/game/' + starPicTwo + '.png')" :style="{right:100/barWidth*starTimeTwo-5+'%'}" class="game_top_process_bar_startwo game_top_process_bar_star" />
                    <img :src="require('@/assets/images/game/' + starPicThree + '.png')" :style="{right:100/barWidth*starTimeThree-5+'%'}" class="game_top_process_bar_starthree game_top_process_bar_star" />
                </div>
            </div>
            <div class="game_top_time">
                {{time}}s
            </div>
            <div class="game_top_pause">
                <img src="@/assets/images/game/pause.png" class="game_top_pause_pic" v-if="pauseFlag" @click="pause" />
                <img src="@/assets/images/game/start.png" class="game_top_pause_pic" v-if="!pauseFlag" @click="start" />
            </div>
        </div>
        <div class="game_left" v-if="level<12">
            <img src="@/assets/images/game/girl.png" class="game_left_girl" />
            <img src="@/assets/images/game/kuang.png" class="game_left_kuang" />
            <div class="game_left_words">
                <p class="game_left_words_top">请在{{barWidth}}s内完成{{times}}次</p>
                <p class="game_left_words_bot"><span>{{text}}</span>消消乐</p>
            </div>
        </div>
        <div class="game_box" v-if="level<12">
            <div class="game_box_fish" v-if="level<5">
                <div   :class="[isactive1===index?'borClass':'','game_box_fish_kuang']" v-for="(item, index) in dataList" :key="index" @click="imgClick(item,index)" @animationend="reset">
                    <img v-if="item !== 5 " :src="require('@/assets/images/game/one/' + picSex + '/'+ item + '.png')" :class="[isactive===index?'addclass':'','game_box_fish_kuang_pic']" />
                </div>
            </div>
            <img :src="require('@/assets/images/game/one/'+ picSex + '/' + lastGameFlag + '.png')" class="imgClass"  v-if="level<5" :class="imgflag?'addclass1':''" />
            <img :src="require('@/assets/images/game/one/'+ picSex + '/' + lastGameFlag + '.png')" class="imgClass1" v-if="level<5" :class="imgflag?'addclass2':''" />
            <div class="game_box_heart" v-if="level>4">
                <div :class="[isactive1===index?'borClass':'','game_box_heart_kuang']" v-for="(item, index) in dataList" :key="index" @click="imgClick(item,index)" @animationend="reset">
                    <img v-if="item !== 5 " :src="require('@/assets/images/game/two/' + picSex + '/' + item + '.png')" :class="[isactive===index?'addclass':'','game_box_heart_kuang_pic']" />
                </div>
            </div>
            <img :src="require('@/assets/images/game/two/'+ picSex + '/' + lastGameFlag + '.png')" class="imgClass"  :class="imgflag?'addclass1':''" v-if="level>4" />
            <img :src="require('@/assets/images/game/two/'+ picSex + '/' + lastGameFlag + '.png')" class="imgClass1" :class="imgflag?'addclass2':''" v-if="level>4" />
        </div>
        <div class="game_box1" v-if="level<35 && level>11">
            <div class="game_left1">
                <img src="@/assets/images/game/girl.png" class="game_left_girl" />
                <div class="game_left_words">
                    <p class="game_left_words_top">请在{{barWidth}}s内完成{{times}}次</p>
                    <p class="game_left_words_bot"><span>{{text}}</span>消消乐</p>
                </div>
            </div>
            <div class="game_box_house">
                <div :class="[isactive1===index?'borClass':'','game_box_house_kuang']" v-for="(item, index) in dataList" :key="index" @click="imgClick(item,index)" @animationend="reset">
                    <img v-if="item !== 5 " :src="require('@/assets/images/game/three/' + picSex + '/' + item + '.png')" :class="[isactive===index?'addclass':'','game_box_house_kuang_pic']" />
                </div>
            </div>
            <img :src="require('@/assets/images/game/three/'+ picSex + '/' + lastGameFlag + '.png')" class="imgClass"  :class="imgflag?'addclass1':''" />
            <img :src="require('@/assets/images/game/three/'+ picSex + '/' + lastGameFlag + '.png')" class="imgClass1" :class="imgflag?'addclass2':''" />
        </div>
        <div class="game_box2" v-if="level == 35">
            <div class="game_left1">
                <img src="@/assets/images/game/girl.png" class="game_left_girl" />
                <div class="game_left_words">
                    <p class="game_left_words_top">请在{{barWidth}}s内完成{{times}}次</p>
                    <p class="game_left_words_bot"><span>{{text}}</span>消消乐</p>
                </div>
            </div>
            <div class="game_box_tree">
                 <div :class="[isactive1===index?'borClass':'','game_box_tree_kuang']" v-for="(item, index) in dataList" :key="index" @click="imgClick(item,index)" @animationend="reset">
                    <img v-if="item !== 5 " :src="require('@/assets/images/game/four/' + picSex + '/' + item + '.png')" :class="[isactive===index?'addclass':'','game_box_tree_kuang_pic']" />
                </div>
            </div>
            <img :src="require('@/assets/images/game/four/'+ picSex + '/' + lastImg + '.png')"  class="imgClass"  :class="imgflag?'addclass1':''" />
            <img :src="require('@/assets/images/game/four/'+ picSex + '/' + lastImg + '.png')"  class="imgClass1" :class="imgflag?'addclass2':''" />
        </div>
        <goback-info :infoShow="goBackFlag" :infoMsg="infoMsg" @infoClose="infoClose" @goback="goback"></goback-info>
        <fail-info :infoShow="failFlag" :infoMsg="failMsg"  @restart="restart" @goback="goback"></fail-info>
        <success-info :infoShow="successFlag" :infoMsg="successMsg" :num="starNumber" :nextFlag="nextFlag" @next="next" @goback="goback"></success-info>
        <pause-info :infoShow="pauseFlag" :infoMsg="pauseMsg"  @goback="goback" @restart="restart" @start="start" ></pause-info>
        <!-- 超时提示框 -->
        <timeout-info :infoShow="timeoutShow" :infoMsg="timeoutMsg" @goback="goback"></timeout-info>
    </div>
</template>
<script>
import Vue from 'vue';
import gobackInfo from '../../components/game/goback-info.vue'
import failInfo from '../../components/game/fail-info.vue'
import successInfo from '../../components/game/success-info.vue'
import pauseInfo from '../../components/game/pause-info.vue'
import timeoutInfo from "./../../components/jigsaw/timeout-info.vue";
import { _getGameStart, _getGameEnd, _getPlayTimeLimit, _setGameLevel, _getWrong } from '../../api/game';
import {horizontalScreen} from '../../assets/js/horizontal';
export default {
    data () {
        return {
            time:40,//倒计时时间
            barWidth:40,//进度条占比
            starPicOne:'man-star',//第一个小星星
            starPicTwo:'man-star',//第二个小星星
            starPicThree:'man-star',//第三个小星星
            starTimeTwo:26,//第三个小星星消失时间
            starTimeThree:13,//第二个小星星消失时间
            pauseFlag:true,//是否暂停
            times:8,//完成次数
            dataList:[],//表情数据
            isactive:'',//是否抖动
            isactive1:'',//点击正确的样式标识
            num:0,//点击次数
            numOne:'',//点击的是第几个正确的表情
            imgflag: false,//正确碰撞效果
            text:'愉快',//消除表情名称
            level:1,//关卡
            goBackFlag:false,//返回关卡弹窗标识
            infoMsg:'还没完成哦，确定要退出吗',//退出话语
            failFlag:false,//失败弹窗标识
            failMsg:'时间到了，再试一次吧～',//失败话语
            successFlag:false,//成功弹窗标识
            successMsg:'恭喜通关',//成功标识
            success:false,//成功弹窗关闭控制时间
            starNumber:'',//成功时星星数量
            lastGameFlag:1,//最后一关消除表情标识
            lastImg:1, //最后一关碰撞图片
            nextFlag:false, //是否显示下一关按钮
            gameTimes:0, //消除次数
            goActiveFlag:false,
            pauseMsg:'休息一下吧~',
            resetTime:0,// 剩余游戏可玩时长,单位（S）
            timeoutShow:false,// 是否展示超过一小时提示框
            intervalTimer:null,//获取游戏可玩时长计时器
            intervalTime:60000,//刷新接口获取时间游戏可玩时长的间隔时间
            timeoutMsg:"您已经持续一个小时玩游戏了,该让眼睛休息啦,还想玩的话,请明天再来吧！", //1小时弹窗话语
            picSex:'woman',
            childId:''
        }
    },
    components:{
        gobackInfo,
        failInfo,
        successInfo,
        pauseInfo,
        timeoutInfo
    },
    watch:{
        time: {
            handler(newValue) {
                if(this.barWidth-newValue == this.starTimeThree) {
                    this.starPicThree = 'kongStar';
                    localStorage.setItem('starPicThree', this.starPicThree);
                }
                if(this.barWidth-newValue == this.starTimeTwo) {
                    this.starPicTwo = 'kongStar';
                    localStorage.setItem('starPicTwo', this.starPicTwo);
                }
                if(newValue == 0) {
                    this.starPicOne = 'kongStar';
                    localStorage.setItem('starPicOne', this.starPicOne);
                    clearInterval(this.timer);
                }
                localStorage.setItem('time', newValue);
            }
        }
    },
    beforeDestroy(){
	    clearInterval(this.intervalTimer);
    },
    mounted() {
         horizontalScreen();
        //  this.$refs.bgmusic.play();
         this.childId = localStorage.getItem("childId");
        if(localStorage.getItem("sex") == 1) {
            this.picSex = 'man';
        } else {
            this.picMan = 'woman';
        }
        this.level = localStorage.getItem('level');
        if(localStorage.getItem('flag') == 1) {
            // this.$refs.go.play();
            localStorage.setItem('flag', 2);
            this.dataSort();
            this.goActiveFlag = true;
        } else {
            this.time = localStorage.getItem('time');
            this.dataList =JSON.parse(localStorage.getItem('dataList'));
            this.barWidth = localStorage.getItem('barWidth');
            this.times = localStorage.getItem('times');
            this.starTimeTwo = localStorage.getItem('starTimeTwo');
            this.starTimeThree = localStorage.getItem('starTimeThree');
            this.pauseFlag = JSON.parse(localStorage.getItem('pauseFlag'));
            this.goBackFlag = JSON.parse(localStorage.getItem('goBackFlag'));
            this.failFlag = JSON.parse(localStorage.getItem('failFlag'));
            this.successFlag = JSON.parse(localStorage.getItem('successFlag'));
            this.success = JSON.parse(localStorage.getItem('success'));
            this.starPicOne = localStorage.getItem('starPicOne');
            this.starPicTwo = localStorage.getItem('starPicTwo');
            this.starPicThree = localStorage.getItem('starPicThree');
            this.text = localStorage.getItem('text');
            this.lastGameFlag = Number(localStorage.getItem('lastGameFlag'));
            this.nextFlag = JSON.parse(localStorage.getItem('nextFlag'));
            this.gameTimes = localStorage.getItem('gameTimes');
            this.starNumber = localStorage.getItem('starNumber');
            if(this.pauseFlag && !this.success) {
                this.timep();
            }
        }
        this.queryBeginTime();
    },
    created() {
        
    },
    methods:{
        dataSort() {
            
            if(this.level == 35) {
                 this.lastGameFlag =1;
                 this.text = '愉快';
            } else {
                if(this.level % 4 == 1) {
                    this.lastGameFlag =1;
                    this.text = '愉快';
                } else if(this.level % 4 == 2) {
                    this.lastGameFlag =2;
                    this.text = '悲伤';
                } else if(this.level % 4 == 3) {
                    this.lastGameFlag =3;
                    this.text = '害怕';
                } else {
                     this.lastGameFlag =4;
                     this.text = '生气';
                }
            }
           if(this.level == 1) {
               this.dataList = [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 2){
               this.dataList = [1,1,1,1,2,2,2,2,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 3){
               this.dataList = [1,1,1,1,3,3,3,3,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 4){
               this.dataList = [1,1,1,1,4,4,4,4,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 5 || this.level == 9){
               this.dataList = [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 6 || this.level == 10){
               this.dataList = [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,2,2,2,2,2,2,2,2,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 7 || this.level == 11){
               this.dataList = [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,3,3,3,3,3,3,3,3,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 8){
               this.dataList = [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 12 || this.level == 16 || this.level == 20 || this.level == 24 || this.level == 28 || this.level == 32){
               this.dataList= [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,2,2,2,2,3,3,3,3,4,4,4,4,4,4,4,4,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 13 || this.level == 17 || this.level == 21 || this.level == 25 || this.level == 29 || this.level == 33){
               this.dataList= [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 14 || this.level == 18 || this.level == 22 || this.level == 26 || this.level == 30 || this.level == 34){
               this.dataList= [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,2,2,2,2,2,2,2,2,2,2,2,2,3,3,3,3,4,4,4,4,2,2,2,2,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 15 || this.level == 19 || this.level == 23 || this.level == 27 || this.level == 31){
               this.dataList= [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,3,3,3,3,3,3,3,3,2,2,2,2,3,3,3,3,4,4,4,4,3,3,3,3,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
           } else if(this.level == 35){
               this.dataList= [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1];
           }
           
            if(this.level<5) {
                this.time = 40;
                // this.dataList = [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
                this.barWidth = 40;
                this.times = 4;
                this.starTimeTwo = 27;
                this.starTimeThree = 14;
            } else if(this.level>4 && this.level<12 ) {
                this.time = 60;
                // this.dataList= [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
                this.barWidth = 60;
                this.times = 8;
                this.starTimeTwo = 41;
                this.starTimeThree = 21;
            } else if(this.level>11 && this.level<35 ) {
                this.time = 80;
                // this.dataList= [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4];
                this.barWidth = 80;
                this.times = 12;
                this.starTimeTwo = 54;
                this.starTimeThree = 27;
            }else if(this.level == 35 ) {
                this.time = 120;
                // this.dataList= [1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,1,1,1,1];
                this.barWidth = 120;
                this.times = 14;
                this.starTimeTwo = 81;
                this.starTimeThree = 41;
            }
            setTimeout(()=>{
                this.timep();
            },1000);
            this.starPicOne='man-star';
            this.starPicTwo='man-star';
            this.starPicThree='man-star';
            this.success = false;
            this.gameTimes = 0;
            this.dataList.sort(() => Math.random() - 0.5);
            localStorage.setItem('time', this.time);
            localStorage.setItem('dataList', JSON.stringify(this.dataList));
            localStorage.setItem('barWidth', this.barWidth);
            localStorage.setItem('times', this.times);
            localStorage.setItem('text', this.text);
            localStorage.setItem('starPicOne', this.starPicOne);
            localStorage.setItem('starPicTwo', this.starPicTwo);
            localStorage.setItem('starPicThree', this.starPicThree);
            localStorage.setItem('starTimeTwo', this.starTimeTwo);
            localStorage.setItem('starTimeThree', this.starTimeThree);
            localStorage.setItem('pauseFlag',JSON.stringify(this.pauseFlag));
            localStorage.setItem('goBackFlag',JSON.stringify(this.goBackFlag));
            localStorage.setItem('failFlag',JSON.stringify(this.failFlag));
            localStorage.setItem('successFlag',JSON.stringify(this.successFlag));
            localStorage.setItem('success',JSON.stringify(this.success));
            localStorage.setItem('lastImg', this.lastImg);
            localStorage.setItem('lastGameFlag', this.lastGameFlag);
            localStorage.setItem('nextFlag',JSON.stringify(this.nextFlag));
            localStorage.setItem('gameTimes', this.gameTimes);
            localStorage.setItem('starNumber',this.starNumber);
            
        },
        //返回按钮
        goBackbox() {
            clearInterval(this.timer);
            this.goBackFlag = true;
            localStorage.setItem('goBackFlag', JSON.stringify(this.goBackFlag));
        },
        //倒计时
         timep() {
            if(!this.timeoutShow) {
                 this.timer = setInterval(()=>{
                    this.time--;
                    if(this.time == 0){
                        clearInterval(this.timer);
                        setTimeout (()=>{
                            this.failFlag= true;
                            this.goActiveFlag = false;
                            localStorage.setItem('failFlag', JSON.stringify(this.failFlag));
                        },100);
                    }
                    // localStorage.setItem('time', this.time);
                },1000);
            }
        },
        //暂停
        pause() {
            if(this.time>0 && !this.success) {
                this.pauseFlag = false;
                this.goActiveFlag = false;
                clearInterval(this.timer);
                localStorage.setItem('pauseFlag', JSON.stringify(this.pauseFlag));
            }
        },
        //开始
        start() {
            if(this.time>0 && !this.success) {
                this.pauseFlag = true;
                this.timep();
                localStorage.setItem('pauseFlag', JSON.stringify(this.pauseFlag));
            }
        },
        //抖动动画结束清除isactive
        reset() {
            if(this.timeoutShow){
                return
            }
            this.isactive = '';
            this.goActiveFlag = false;
        },
        //图片点击
        imgClick(item,index) {
            this.imgNone(item,index);
        },
        //是否消除表情
        imgNone(item,index){
            this.goActiveFlag = false;
            if(this.pauseFlag && this.time>0) {
                if(item !== this.lastGameFlag) {
                    this.num = 0;
                    this.isactive = index;  
                    this.numOne= '';
                    this.isactive1 = '';
                    this.wrong(this.lastGameFlag,item)
                } else {
                    this.isactive1 = index;
                    if(this.numOne !== index){
                        this.num++;
                        if(this.num == 1) {
                            this.numOne = index;
                            this.imgflag = false;
                        }
                        if(this.num == 2) {
                            this.isactive1 = '';
                            Vue.set(this.dataList,index,5);
                            Vue.set(this.dataList,this.numOne,5);
                            this.gameTimes++;
                            localStorage.setItem('gameTimes',this.gameTimes);
                            localStorage.setItem('dataList', JSON.stringify(this.dataList));
                            this.imgflag = true;
                            let a =this.dataList.indexOf(this.lastGameFlag);
                            if(this.lastGameFlag == 2) {
                                this.lastImg = 2;
                            }else if(this.lastGameFlag == 3) {
                                this.lastImg = 3;
                            } else if(this.lastGameFlag == 4) {
                                this.lastImg = 4;
                            }
                            localStorage.setItem('lastImg', this.lastImg);
                            if(a == -1) {
                                if(this.level == 35 && this.lastGameFlag<4) {
                                    this.lastGameFlag++;
                                    localStorage.setItem('lastGameFlag', this.lastGameFlag);
                                    if(this.lastGameFlag == 2) {
                                        this.text = '悲伤';
                                        this.times = 6;
                                    } else if(this.lastGameFlag == 3) {
                                        this.text = '害怕';
                                        this.times = 6;
                                    } else if(this.lastGameFlag == 4) {
                                        this.text = '生气';
                                        this.times = 6;
                                    }
                                    localStorage.setItem('text', this.text);
                                    localStorage.setItem('times', this.times);
                                } else {
                                    clearInterval(this.timer);
                                    // this.success = true;
                                    // localStorage.setItem('success', JSON.stringify(this.success));
                                    // setTimeout (()=>{
                                    //     this.successFlag = true;
                                    //     localStorage.setItem('successFlag', JSON.stringify(this.successFlag));
                                    // },1100);
                                    if(this.starPicThree == 'man-star') {
                                        this.starNumber = 3;
                                    } else if(this.starPicTwo == 'man-star' && this.starPicThree == 'kongStar') {
                                        this.starNumber = 2;
                                    } else {
                                        this.starNumber = 1;
                                    }
                                    if(this.level == 35) {
                                        this.nextFlag = true;
                                    } else {
                                        this.nextFlag = false;
                                    }
                                    this.saveGameLevel(this.level,true,this.starNumber);
                                    localStorage.setItem('nextFlag',JSON.stringify(this.nextFlag));
                                    localStorage.setItem('starNumber',this.starNumber);
                                }
                            }
                        this.num =0;
                        }
                    }
                }
            }
        },
        //关闭弹窗
        infoClose() {
            this.goBackFlag = false;
            localStorage.setItem('goBackFlag', JSON.stringify(this.goBackFlag));
            this.timep();
            localStorage.setItem('pauseFlag', JSON.stringify(this.pauseFlag));
        },
        //返回关卡页面
        goback() {
            this.queryGameEnd();
            this.failFlag = false;
            this.successFlag = false;
            this.goBackFlag = false;
            localStorage.setItem('failFlag', JSON.stringify(this.failFlag));
            localStorage.setItem('successFlag', JSON.stringify(this.successFlag));
            localStorage.setItem('goBackFlag', JSON.stringify(this.goBackFlag));
            this.$emit('gamegoback',this.nextFlag);
            // this.$router.push({
            //     path:'/gameIndex',
            //     query:{
            //         nextFlag: this.nextFlag
            //     }
            // })
        },
        //再来一次
        restart() {
            this.$refs.go.play();
            this.isactive1 = '';
            this.goActiveFlag = true;
            this.num = 0;
            this.dataSort();
            this.failFlag = false;
            this.pauseFlag = true;
            // this.$refs.bgmusic.play();
            localStorage.setItem('failFlag', JSON.stringify(this.failFlag));
            localStorage.setItem('pauseFlag', JSON.stringify(this.pauseFlag));
            this.lastImg = 1;
            localStorage.setItem('text', this.text);
            localStorage.setItem('lastImg', this.lastImg);
            this.$emit('restart');
        },
        //下一关
        next() {
            this.$refs.go.play();
            this.goActiveFlag = true;
            this.level++;
            localStorage.setItem('level', this.level);
            // this.$refs.bgmusic.play();
            this.imgflag = false;
            this.dataSort();
            this.successFlag = false;
            localStorage.setItem('successFlag', JSON.stringify(this.successFlag));
            this.success = false;
            localStorage.setItem('success', JSON.stringify(this.success));
            this.$emit('next');
        },
        // 标记游戏开始
        queryBeginTime() {
            _getGameStart({
                studentId:this.childId,
                gameType: '1',
                currentLevel:this.level
            }).then(res=>{
                if(res.code == 200) {
                    this.queryGameLimitTime();
                    // 获取游戏时长
                    this.intervalTimer = setInterval(()=>{
                        this.queryGameLimitTime();
                    },this.intervalTime)
                } else if(res.code == 1010003) {
                    this.$emit('musicPause');
                    this.timeoutShow = true;
                    this.goActiveFlag = false;
                    this.pauseFlag = true;
                    this.successFlag = false;
                    this.failFlag = false;
                    this.goBackFlag = false;
                    localStorage.setItem('pauseFlag',JSON.stringify(this.pauseFlag));
                    localStorage.setItem('successFlag',JSON.stringify(this.successFlag));
                    localStorage.setItem('failFlag',JSON.stringify(this.failFlag));
                    localStorage.setItem('goBackFlag',JSON.stringify(this.goBackFlag));
                    clearInterval(this.timer);
                    clearInterval(this.intervalTimer);
                }
            })
        },
        // 记录游戏结束
      queryGameEnd() {
         _getGameEnd({
                studentId:this.childId,
                gameType: '1',
                currentLevel:this.level
            })
      },
      // 获取游戏可玩时长
      queryGameLimitTime() {
         _getPlayTimeLimit({studentId:this.childId}).then(res=>{
            if(res.code == 200){
               this.resetTime = res.data;
               if(this.resetTime == 0){
                   this.$emit('musicPause');
                  // 超时弹框提醒
                  this.timeoutShow = true;
                  this.goActiveFlag = false;
                  this.pauseFlag = true;
                  this.successFlag = false;
                  this.failFlag = false;
                  this.goBackFlag = false;
                  localStorage.setItem('pauseFlag',JSON.stringify(this.pauseFlag));
                  localStorage.setItem('successFlag',JSON.stringify(this.successFlag));
                  localStorage.setItem('failFlag',JSON.stringify(this.failFlag));
                  localStorage.setItem('goBackFlag',JSON.stringify(this.goBackFlag));
                  clearInterval(this.timer);
                  clearInterval(this.intervalTimer);
               }
            }
         })
      },
      // 游戏结束，保存关卡
      saveGameLevel(currentLevel,isCurrentPassed,scoreStars) {
         let params = {
            currentLevel:currentLevel,
            gameType:'1',
            isCurrentPassed:isCurrentPassed,
            scoreStars:scoreStars,
            studentId:this.childId
         }
         _setGameLevel(params).then(res=>{
            if(res.code == 200){
                this.success = true;
                localStorage.setItem('success', JSON.stringify(this.success));
                setTimeout (()=>{
                    this.successFlag = true;
                    localStorage.setItem('successFlag', JSON.stringify(this.successFlag));
                },1100);
            }else{
               Toast({message:res.message,className:'rotation'});
            }
         })
      },
      wrong(rightBlock,wrongBlock) {
           let params = {
            currentLevel:this.level,
            gameType:'1',
            studentId:this.childId,
            rightBlock:rightBlock,
            wrongBlock:wrongBlock
         }
          _getWrong(params)
      }
    }
}
</script>
<style lang='scss' scoped>
    .game {
        height: 100%;
        width: 100%;
        background: url(./../../assets/images/game/bacground.png);
        background-size: cover;
        position: relative;
        #bgmusic{
            display:none;
        }
        .game_left {
            position: absolute;
            top: 90px;
            left: 6px;
            .game_left_girl {
                width: 53px;
                height: 82px;
                display: block;
            }
            .game_left_kuang {
                width: 130px;
                height: 55px;
                margin-top: -25px;
                background: url(./../../assets/images/game/kuang.png);
                background-size: cover;
            }
            .game_left_words {
                position: absolute;
                width: 130px;
                top: 67px;
                .game_left_words_top {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 17px;
                    text-align: center;
                }
                .game_left_words_bot {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 17px;
                    text-align: center;
                    span {
                        font-size: 18px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FF7C1F;
                        line-height: 25px;
                    }
                }
            }
        }
        .game_top {
            display: flex;
            .game_top_back {
                width: 29px;
                height: 29px;
                margin: 15px 0 0 15px;
            }
            .game_top_guanka {
                width: 72px;
                height: 62px;
                background: url(./../../assets/images/game/guanka.png) no-repeat;
                background-size: contain;
                margin-left: 50px;
                .game_top_guanka_title {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 17px;
                    text-align: center;
                    margin-top: 7px;
                }
                .game_top_guanka_num {
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                    line-height: 20px;
                    text-align: center;
                }
            }
            .game_top_times {
                width: 80px;
                height: 39px;
                background: url(./../../assets/images/game/times.png);
                background-size: cover;
                margin-left: 17px;
                margin-top: 5px;
                p {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FE8A23;
                    line-height: 39px;
                    text-align: right;
                    margin-right: 10px;
                }
            }
            .game_top_process {
                width: 165px;
                height: 39px;
                background: url(./../../assets/images/game/precess.png);
                background-size: cover;
                margin-left: 13px;
                margin-top: 5px;
                .game_top_process_bar {
                    width: 105px;
                    height: 11px;
                    margin-top: 14px;
                    box-shadow: 0px 0px 3px 0px #FF7F7F;
                    border-radius: 5px;
                    margin-left: 50px;
                    display: flex;
                    justify-content: center;
                    position: relative;
                    .game_top_process_bar_left {
                        background: linear-gradient(180deg, #FF9191 0%, #FF5858 100%);
                        height: 11px;
                    }
                    .game_top_process_bar_right {
                        height: 11px;
                        background: #FFDEDE;
                    }
                    .game_top_process_bar_star {
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        top: -7px;
                    }
                    .game_top_process_bar_starone {
                        left: -10px;
                    }
                }
            }
            .game_top_time {
                width: 45px;
                height: 25px;
                background: #FFFFFF;
                border-radius: 6px;
                border: 2px solid #F35454;
                margin-left: 5px;
                margin-top: 12px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #F35454;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .game_top_pause {
                margin-left: 15px;
                margin-top: 10px;
                .game_top_pause_pic {
                    width: 30px;
                    height: 30px;
                }
            }
        }
        .game_box {
            width: 362px;
            height: 287px;
            background: url(./../../assets/images/game/game-box.png);
            background-size: cover;
            margin: 0 auto;
            position: relative;
            .game_box_fish {
                width: 238px;
                height: 238px;
                transform: rotate(-45deg);
                margin-left: 70px;
                padding-top:35px ;
                .game_box_fish_kuang {
                    width: 34px;
                    height: 34px;
                    margin-right: 4px;
                    margin-bottom: 4px;
                    background: #D8CBFC;
                    border-radius: 6px;
                    float: left;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .game_box_fish_kuang_pic {
                        width: 25px;
                        height: 25px;
                        transform: rotate(45deg);
                    }
                }
                .game_box_fish_kuang:nth-child(4),.game_box_fish_kuang:nth-child(8),.game_box_fish_kuang:nth-child(12){
                    margin-right: 76px;
                }
                .game_box_fish_kuang:nth-child(19),.game_box_fish_kuang:nth-child(20) {
                    margin-right: 76px;
                    margin-left: 114px;
                }
                .game_box_fish_kuang:nth-child(16){
                    margin-right: 14px;
                    margin-bottom: 14px;
                }
            }
            .game_box_heart {
                width: 304px;
                margin-left: 30px;
                padding-top: 12px;
                .game_box_heart_kuang {
                    width: 34px;
                    height: 34px;
                    margin-right: 4px;
                    margin-bottom: 4px;
                    background: #D8CBFC;
                    border-radius: 6px;
                    float: left;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .game_box_heart_kuang_pic {
                        width: 25px;
                        height: 25px;
                    }
                }
                .game_box_heart_kuang:nth-child(1){
                    margin-left: 55px;
                }
                .game_box_heart_kuang:nth-child(2) {
                    margin-right: 42px;
                }
                .game_box_heart_kuang:nth-child(4) {
                    margin-right: 55px;
                }
                .game_box_heart_kuang:nth-child(29) {
                    margin-left: 38px;
                }
                .game_box_heart_kuang:nth-child(34) {
                    margin-right: 38px;
                }
                .game_box_heart_kuang:nth-child(35) {
                    margin-left: 76px;
                }
                .game_box_heart_kuang:nth-child(38) {
                    margin-right: 76px;
                }
                .game_box_heart_kuang:nth-child(39) {
                    margin-left: 114px;
                }
            }
        }
        .game_box1 {
            width: 627px;
            height: 308px;
            background: url(./../../assets/images/game/game-box.png);
            background-size: 100% 100%;
            margin: 0 auto;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            .game_left1 {
                position: absolute;
                top: 5px;
                left: 5px;
                display: flex;
                z-index: 2;
                .game_left_girl {
                    width: 53px;
                    height: 82px;
                }
                .game_left_kuang {
                    width: 150px;
                    height: 55px;
                    background: url(./../../assets/images/game/kuang1.png);
                    margin-top: 10px;
                    background-size: 100% 100%;
                }
                .game_left_words {
                    width: 150px;
                    height: 55px;
                    margin-top: 15px;
                    background: url(./../../assets/images/game/kuang1.png);
                    background-size: 100% 100%;
                    text-align: center;
                    .game_left_words_top {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 17px;
                        text-align: center;
                        margin-top: 7px;
                        margin-left: 4px;
                    }
                    .game_left_words_bot {
                        margin-left: 4px;
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 17px;
                        text-align: center;
                        span {
                            font-size: 18px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #FF7C1F;
                            line-height: 25px;
                        }
                    }
                }
            }
            .game_box_house {
                width: 532px;
                .game_box_house_kuang {
                    width: 34px;
                    height: 34px;
                    margin-right: 4px;
                    margin-bottom: 4px;
                    background: #D8CBFC;
                    border-radius: 6px;
                    float: left;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .game_box_house_kuang_pic {
                        width: 25px;
                        height: 25px;
                    }
                }
                .game_box_house_kuang:nth-child(1) {
                    margin-left: 266px;
                }
                .game_box_house_kuang:nth-child(2) {
                    margin-right: 190px;
                }
                .game_box_house_kuang:nth-child(3) {
                    margin-left: 190px;
                }
                .game_box_house_kuang:nth-child(7) {
                    margin-right: 152px;
                }
                .game_box_house_kuang:nth-child(9),.game_box_house_kuang:nth-child(32) {
                    margin-left: 76px;
                }
                .game_box_house_kuang:nth-child(20) {
                    margin-left: 38px;
                }
                .game_box_house_kuang:nth-child(30),.game_box_house_kuang:nth-child(41) {
                    margin-right: 42px;
                }
                .game_box_house_kuang:nth-child(43) {
                    margin-left: 114px;
                }
                .game_box_house_kuang:nth-child(54) {
                    margin-left: 152px;
                }
               
            }
        }
        .game_box2 {
            width: 627px;
            height: 308px;
            background: url(./../../assets/images/game/game-box.png);
            background-size: 100% 100%;
            margin: 0 auto;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            .game_left1 {
                position: absolute;
                top: 5px;
                left: 5px;
                display: flex;
                z-index: 2;
                .game_left_girl {
                    width: 53px;
                    height: 82px;
                }
                .game_left_kuang {
                    width: 130px;
                    height: 55px;
                    background: url(./../../assets/images/game/kuang1.png);
                    margin-top: 10px;
                    background-size: 100% 100%;
                }
                .game_left_words {
                    width: 150px;
                    height: 55px;
                    margin-top: 15px;
                    background: url(./../../assets/images/game/kuang1.png);
                    background-size: 100% 100%;
                    text-align: center;
                    .game_left_words_top {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 17px;
                        text-align: center;
                        margin-top: 7px;
                        margin-left: 4px;
                    }
                    .game_left_words_bot {
                        margin-left: 4px;
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 17px;
                        text-align: center;
                        span {
                            font-size: 18px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #FF7C1F;
                            line-height: 25px;
                        }
                    }
                }
            }
            .game_box_tree {
                width: 608.1px;
                .game_box_tree_kuang {
                    width: 34px;
                    height: 34px;
                    margin-right: 4px;
                    margin-bottom: 4px;
                    background: #D8CBFC;
                    border-radius: 6px;
                    float: left;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .game_box_tree_kuang_pic {
                        width: 25px;
                        height: 25px;
                    }
                }
                .game_box_tree_kuang:nth-child(1) {
                    margin-left: 342px;
                }
                .game_box_tree_kuang:nth-child(2),.game_box_tree_kuang:nth-child(6) {
                    margin-right: 190px;
                }
                .game_box_tree_kuang:nth-child(3){
                    margin-left: 266px;
                }
                .game_box_tree_kuang:nth-child(7){
                    margin-left: 228px;
                }
                .game_box_tree_kuang:nth-child(12){
                    margin-right: 152px;
                }
                .game_box_tree_kuang:nth-child(29){
                    margin-left: 38px;
                }
                .game_box_tree_kuang:nth-child(42){
                    margin-right: 38px;
                }
                .game_box_tree_kuang:nth-child(43){
                    margin-left: 76px;
                }
               .game_box_tree_kuang:nth-child(54){
                    margin-right: 76px;
                }
                .game_box_tree_kuang:nth-child(55){
                    margin-left: 114px;
                }
            }
        }
        .addclass{ 
            -webkit-animation: bounce-up 0.1s linear;
            animation: bounce-up 0.1s linear;
        }
        .borClass {
            box-shadow: 0px 1px 4px 0px #9D7AF5;
            border: 1px solid #9D7AF5;
        }
        .imgClass {
            position:absolute;
            width: 25px;
            left: 0%; 
            top: 50%;   
            transform: translate(0, -50%);
            opacity: 0;
        }
        .imgClass1 {
            position:absolute;
            width: 25px;
            right: 0%; 
            top: 50%;   
            transform: translate(0%, -50%);
            opacity: 0;
        }

        .word-go {
            position: absolute;
            width: 100%;
            display: block;
            color: red;
            text-align: center;
            transform: scale(0);
            opacity: 0;
            line-height: 400px;
            z-index: 9999999999;
            animation: goSlide 1.5s 0s;
        }

        // .goActive {
        //     animation: goSlide 1.5s 0s;
        // }
        @keyframes readySlide {
            from {
                opacity: 1;
                transform: translateY(-150%);
            }
            to {
                transform: translateY(0);
                opacity: 0;
            }
        }

        @keyframes goSlide {
            from {
                opacity: 0;
                transform: scale(0);
            }
            to {
                transform: scale(1.7);
                opacity: 1;
            }
        }
        @-webkit-keyframes bounce-up {
            25% {-webkit-transform: translateX(10px);}
            50%, 100% {-webkit-transform: translateX(0);}
            75% {-webkit-transform: translateX(-10px);}
        }

        @keyframes bounce-up {
            25% {transform: translateX(10px);}
            50%, 100% {transform: translateX(0);}
            75% {transform: translateX(-10px);}
        }
         .addclass1{ 
            -webkit-animation: forward 1s linear;
            animation: forward 1s linear;
        }
        .addclass2{ 
            -webkit-animation: forward 1s linear;
            animation: forward1 1s linear;
        }
        @keyframes forward {
            0% {left: 0;opacity: 1;transform:scale(3);}
            50% {left: 25%;opacity: 1;transform:scale(3);}
            100% {left: 40%;opacity: 0;transform:scale(3);}
        }
        @keyframes forward1 {
            0% {right: 0;opacity: 1;transform:scale(3);}
            50% {right: 25%;opacity: 1;transform:scale(3);}
            100% {right: 40%;opacity: 0;transform:scale(3);}
        }
    }
</style>